import { footerLinks } from "@/mocks/site";

const topicLinks = [
  { label: "爱情韩剧", href: "#top-rated" },
  { label: "悬疑韩剧", href: "#top-rated" },
  { label: "古装韩剧", href: "#top-rated" },
  { label: "复仇题材", href: "#top-rated" },
  { label: "治愈系剧集", href: "#library" },
  { label: "青春校园", href: "#library" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-secondary-950 text-background-50">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading font-bold text-lg">韩剧TV</span>
            </div>
            <p className="mt-4 text-sm text-background-50/70 leading-relaxed max-w-md">
              韩剧TV 是一个面向热门韩剧资源需求的信息集合页，围绕正在热播的韩剧、最新韩剧更新、高分韩剧推荐与全集资源，
              并补充独播剧与人气剧榜单，帮你在一个页面里把不同方向的线索核对清楚。
            </p>
            <a
              href="#top"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-label bg-background-50/10 border border-background-50/20 hover:bg-background-50/20 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-up-line" aria-hidden="true" />
              回到顶部
            </a>
          </div>

          <nav className="md:col-span-3" aria-label="页脚分区导航">
            <h4 className="text-sm font-label font-medium tracking-wide text-accent-300">
              页面分区
            </h4>
            <ul className="mt-4 space-y-2.5">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm font-label text-background-50/75 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="md:col-span-4" aria-label="题材导航">
            <h4 className="text-sm font-label font-medium tracking-wide text-accent-300">
              热门题材
            </h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {topicLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="inline-flex px-3 py-1.5 rounded-full text-xs font-label text-background-50/80 bg-background-50/10 border border-background-50/15 hover:bg-background-50/20 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-xs text-background-50/50 leading-relaxed">
              本站内容为剧集信息整理与展示，评分、热度等为站内汇总参考值，实际以各剧集官方信息为准。
            </p>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs font-label text-background-50/55 text-center sm:text-left">
            © {year} 韩剧TV · 韩剧资源信息集合页
          </p>
          <p className="text-xs font-label text-background-50/45">
            热播 · 更新 · 高分 · 全集 · 独播 · 榜单
          </p>
        </div>
      </div>
    </footer>
  );
}